import React, {forwardRef, useRef} from 'react';
import styled from 'styled-components';

const StyledScrollArea = styled.div`
    overflow-y: scroll;
    min-width: 100%;
`

const ScrollArea = forwardRef(({children, ...rest}, forwardedRef) => {
    const ref = useRef();
    const bounds = ref?.current?.getBoundingClientRect();
    let height = '100vh';
    if (bounds) {
        height = window.innerHeight - bounds.y - (rest.trimY?rest.trimY:0);
    }

    return (
        <StyledScrollArea style={{minHeight: height, maxHeight: height}} ref={(node) => {
            ref.current = node;
            if (typeof forwardedRef === 'function') {
                forwardedRef(node);
            } else if (forwardedRef) {
                forwardedRef.current = node;
            }
        }}>
            { children }
        </StyledScrollArea>
    )
});

export default ScrollArea;
